import { useLocations } from '@/core/hooks/use-locations';
import type { FeedbackMailSampleVars } from '@/core/lib/feedback-mail-preview';
import { useDictionary } from '@/core/providers/dictionary-provider';
import { useCurrentWorkspace } from '@/core/store/workspace.store';

/**
 * Sample values for mail previews outside an invite (editor, library, list),
 * so every surface shows the same example mail.
 */
export function useFeedbackMailSample(): FeedbackMailSampleVars {
  const dict = useDictionary().feedback;
  const workspace = useCurrentWorkspace();
  const { locations } = useLocations();
  return {
    contactName: dict.preview.sampleContact,
    locationName: locations[0]?.name ?? dict.preview.sampleLocation,
    workspaceName: workspace?.name ?? 'up2promo',
  };
}
